// @ts-nocheck
import React, { useContext, useEffect } from 'react';
import Context from '../../context/Context';
import { editFormElement, fetchFormElement } from '../../context/forms/FormsAction';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { URL } from "../../service/Service";
import ElementEdit from "../../components/elementEdit/ElementEdit"
import ElementEditWizard from '../../components/wizardElementEdit/ElementEditWizard';
import { jwtDecode } from 'jwt-decode';

const ElementEditorWizard = () => {
  const { idform, idformelement } = useParams()
  const { state, dispatch } = useContext(Context);
  const { loading, error, data } = state.formelement;
  const token = sessionStorage.getItem('jwt');
  const userRole = jwtDecode(token).authorities[0].authority;
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const url = `${URL}/api/forms/${idform}/formelements/${idformelement}`;
    void fetchFormElement(url, {}, dispatch).catch(() => {
      // The reducer exposes the friendly "element no longer exists" state.
    });
  }, [dispatch, idform, idformelement]);

  useEffect(() => {
    const isAdminPath = location.pathname.startsWith('/admin/forms/');
    const isFormWizard1Path = location.pathname.endsWith('/wizard');

    if (isAdminPath && isFormWizard1Path && userRole !== 'ADMIN') {
      navigate('/login'); // Redirect to login screen if not ADMIN and accessing admin path
    }
  }, [location.pathname, navigate, userRole]);


  if (loading) {
    return <div className="p-8 text-center text-slate-600">A carregar elemento…</div>;
  }

  if (error || !data?.id) {
    const editorPath = `${location.pathname.startsWith('/admin/') ? '/admin' : ''}/forms/${idform}/formwizard/1`;
    return <div className="mx-auto mt-16 max-w-xl rounded-3xl border border-amber-200 bg-amber-50 p-8 text-center text-amber-900 shadow-sm">
      <h1 className="text-xl font-bold">Este elemento já não existe</h1>
      <p className="mt-2 text-sm">Pode ter sido removido ou o endereço estar desatualizado.</p>
      <button type="button" onClick={() => navigate(editorPath, { replace: true })} className="mt-6 rounded-xl bg-emerald-800 px-5 py-3 text-sm font-bold text-white">Voltar ao editor</button>
    </div>;
  }

  return (
    <>
      <ElementEditWizard formElement={data} userRole={userRole} />
    </>
  )
}

export default ElementEditorWizard
